<template>
  <div>
    <div class="mt-md">
      <OnboardingNotifications :pushNotifications="pushNotifications" />
    </div>
    <!-- Navigate -->
    <div class="py-lg">
      <div class="columns">
        <div class="column">
          <b-button
            type="is-light rounded-lg"
            expanded
            @click="goBack"
            size="is-medium"
            ><b-icon icon="arrow-left"></b-icon>
          </b-button>
        </div>
        <div class="column">
          <b-button
            type="is-primary rounded-lg"
            expanded
            :loading="isUpdating"
            @click="goForward"
            size="is-medium"
          >Continue</b-button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import OnboardingNotifications from '@/components/Models/Notifications/Onboarding'
export default {
  components: {
    OnboardingNotifications
  },
  computed: {
    ...mapGetters(['app', 'context'])
  },
  data () {
    return {
      setupIsCompleted: false
    }
  },
  methods: {
    goBack () {
      this.$router.push({ name: 'retailer.onboarding' })
    },
    goForward () {
      this.updateTask()
    },
    updateTask () {
      const taskBody = (typeof this.task.info === 'object') ? { info: this.task.info } : { info: {} }
      taskBody.info.onboarding = true
      this.$emit('task:updated', taskBody, 'retailer.onboarding.transactions')
    }
  },
  mounted () {
    if (this.task && this.task.info && this.task.info.onboarding) {
      this.setupIsCompleted = true
    }
  },
  props: {
    task: {
      type: Object,
      require: true
    },
    pushNotifications: {
      type: Array,
      required: true
    },
    isUpdating: {
      type: Boolean
    }
  }
}
</script>
